/* ============================================================================
   feat-28 — Medición por sección: qué ve, qué toca y desde dónde añade al
   carrito cada usuario. Tres eventos a GA4, con el nombre de la sección:

     section_view          la sección ha estado ≥ 50 % visible (una vez por página)
     section_click         clic dentro de la sección (tope de 20 por página)
     section_add_to_cart   añadir al carrito atribuido a la sección donde se
                           hizo el último clic (15 s); si no hay, «buy-buttons»
                           (formulario principal), «sticky-atc» o «unknown»

   Nombre propio y no `add_to_cart` para no duplicar el que ya manda el canal
   de Google: en BigQuery se cruzan por sesión y usuario.

   Salida a GA4: `window.__lejEnviarGa4(evento, params)`, el emisor de
   `snippets/lej-growthbook.liquid` (hit directo con el mismo cid/sid que la
   navegación; encola hasta que el píxel escribe `_ga`, que solo existe con
   consentimiento de analítica). Un único camino de salida en todo el theme.

   Qué sección es cada cosa: `window.lejSectionTracking.secciones`, que pinta
   `snippets/lej-section-tracking.liquid` (nombre → selectores CSS, por
   página). Un elemento con `data-lej-section="nombre"` también cuenta, sin
   tocar la lista: es la vía para secciones nuevas.

   Volumen: el export GA4 → BigQuery tiene un tope de 1 M de eventos al día y
   la tienda ya anda en 550-600 k (1,0 M el día del lanzamiento Sakura).
   `muestra` (0-1, por usuario, estable por cookie `_ga`) limita el coste:
   0,5 = la mitad de los usuarios, ~250 k eventos/día. El valor viaja en
   `sample` para que ninguna consulta olvide dividir.

   QA: `?lejdebug=1` escribe cada evento en consola y lo manda a GA4 con
   `_dbg=1` (DebugView). Además, cada envío dispara `lej:section-tracking`
   en `document`, para los tests automáticos.
   ========================================================================== */
(function () {
  var cfg = window.lejSectionTracking || {};
  var secciones = cfg.secciones || {};
  var pagina = cfg.pagina || 'other';
  var muestra = typeof cfg.muestra === 'number' ? cfg.muestra : 1;
  var debug = /[?&]lejdebug=1/.test(location.search);
  var ATTR_WINDOW_MS = 15000;
  var MAX_CLICKS = 20;

  function clientIdGa4() {
    var m = document.cookie.match(/(?:^|;\s*)_ga=GA\d\.\d\.([\d.]+)/);
    return m ? m[1] : null;
  }
  /* Muestreo estable por usuario con la cookie `_ga` (su valor = `user_pseudo_id` en BigQuery):
     últimas 3 cifras de la parte aleatoria < muestra × 1000. La misma regla en SQL, para que el
     denominador (page_view) se filtre igual que el numerador:
       MOD(CAST(SUBSTR(SPLIT(user_pseudo_id, '.')[OFFSET(0)], -3) AS INT64), 1000) < muestra * 1000
     Con `?lejdebug=1` siempre dentro, para poder probar. */
  function enMuestra() {
    if (muestra >= 1 || debug) { return true; }
    var cid = clientIdGa4();
    if (!cid) { return false; }
    var aleatoria = cid.split('.')[0];
    var n = parseInt(aleatoria.slice(-3), 10);
    if (isNaN(n)) { return false; }
    return n < muestra * 1000;
  }
  function enviar(en, params) {
    if (typeof window.__lejEnviarGa4 !== 'function' || !enMuestra()) { return false; }
    var p = { 'ep.page_type': pagina, 'epn.sample': muestra };
    for (var k in params) {
      if (Object.prototype.hasOwnProperty.call(params, k) && params[k] !== undefined && params[k] !== '') { p[k] = params[k]; }
    }
    if (debug) { p._dbg = '1'; console.log('[lej-section-tracking]', en, p); }
    window.__lejEnviarGa4(en, p);
    try { document.dispatchEvent(new CustomEvent('lej:section-tracking', { detail: { en: en, params: p } })); } catch (e) {}
    return true;
  }

  /* ── Qué sección es un elemento ─────────────────────────────────────────── */
  var raices = []; // [{ nombre, el }]
  function resolver() {
    raices = [];
    var vistos = [];
    Object.keys(secciones).forEach(function (nombre) {
      var sels = [].concat(secciones[nombre] || []);
      for (var i = 0; i < sels.length; i++) {
        /* Si el selector casa varias veces (p. ej. una fila repetida dentro de un popup
           oculto), gana la primera que se ve; si ninguna se ve, la primera. */
        var lista = [];
        try { lista = document.querySelectorAll(sels[i]); } catch (e) { lista = []; }
        var el = null;
        for (var j = 0; j < lista.length; j++) { if (seVe(lista[j])) { el = lista[j]; break; } }
        if (!el && lista.length) { el = lista[0]; }
        if (el && vistos.indexOf(el) === -1) { raices.push({ nombre: nombre, el: el }); vistos.push(el); break; }
      }
    });
    var marcados = document.querySelectorAll('[data-lej-section]');
    for (var j = 0; j < marcados.length; j++) {
      if (vistos.indexOf(marcados[j]) === -1) {
        raices.push({ nombre: marcados[j].getAttribute('data-lej-section'), el: marcados[j] });
        vistos.push(marcados[j]);
      }
    }
  }
  function seccionDe(el) {
    if (!el || !el.closest) { return null; }
    var marcado = el.closest('[data-lej-section]');
    if (marcado) { return marcado.getAttribute('data-lej-section'); }
    for (var i = 0; i < raices.length; i++) {
      if (raices[i].el === el || raices[i].el.contains(el)) { return raices[i].nombre; }
    }
    return null;
  }

  /* Un cajón cerrado sigue en el DOM (visibility:hidden y desplazado); el observer
     puede darlo por intersecado al arrancar. Solo cuenta lo que de verdad se ve. */
  function seVe(el) {
    var cajon = el.closest && el.closest('cart-drawer, .drawer');
    if (cajon && !cajon.hasAttribute('open')) { return false; }
    var r = el.getBoundingClientRect();
    if (!r.width || !r.height) { return false; }
    var n = el;
    while (n && n !== document.body) {
      var cs = getComputedStyle(n);
      if (cs.visibility === 'hidden' || cs.display === 'none' || cs.opacity === '0' || n.hidden || n.getAttribute('aria-hidden') === 'true') { return false; }
      n = n.parentElement;
    }
    return true;
  }

  /* ── section_view: ≥ 50 % visible (o ≥ 50 % de la pantalla si es más alta) ── */
  var vistas = {};
  var temporizadores = {};
  var io = null;
  var DWELL_MS = 800; // una vista cuenta si la sección sigue a la vista 0,8 s: ni saltos de scroll ni el cajón en tránsito
  function mitadVisible(e) {
    var umbral = Math.min(e.boundingClientRect.height, window.innerHeight) * 0.5;
    return e.isIntersecting && umbral > 0 && e.intersectionRect.height >= umbral;
  }
  function sigueVisible(el) {
    var r = el.getBoundingClientRect();
    var visible = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
    return visible >= Math.min(r.height, window.innerHeight) * 0.5 && seVe(el);
  }
  function observar() {
    if (!('IntersectionObserver' in window)) { return; }
    if (io) { io.disconnect(); }
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var nombre = seccionDe(e.target);
        if (!nombre || vistas[nombre]) { return; }
        if (mitadVisible(e) && seVe(e.target)) {
          if (temporizadores[nombre]) { return; }
          temporizadores[nombre] = setTimeout(function () {
            temporizadores[nombre] = 0;
            if (vistas[nombre] || !sigueVisible(e.target)) { return; }
            vistas[nombre] = true;
            enviar('section_view', { 'ep.section': nombre });
            io.unobserve(e.target);
          }, DWELL_MS);
        } else if (temporizadores[nombre]) {
          clearTimeout(temporizadores[nombre]);
          temporizadores[nombre] = 0;
        }
      });
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
    raices.forEach(function (r) { if (!vistas[r.nombre]) { io.observe(r.el); } });
  }
  if (debug) { window.__lejSectionDiag = function () { return raices.map(function (r) { var b = r.el.getBoundingClientRect(); return { s: r.nombre, w: Math.round(b.width), h: Math.round(b.height), top: Math.round(b.top), seVe: seVe(r.el), vista: !!vistas[r.nombre] }; }); }; }

  /* ── section_click + atribución del último clic ─────────────────────────── */
  var clics = 0;
  var ultimo = { nombre: null, t: 0 };
  function descripcion(target) {
    var a = target.closest && target.closest('a[href*="/products/"]');
    if (a) { return (a.getAttribute('href') || '').split('?')[0].split('/products/').pop().slice(0, 60); }
    var b = target.closest && target.closest('button, a, [role="button"], summary, input, select, label');
    if (!b) { return ''; }
    var t = (b.getAttribute('aria-label') || b.textContent || b.value || '').replace(/\s+/g, ' ').trim();
    return t.slice(0, 40);
  }
  document.addEventListener('click', function (ev) {
    var nombre = seccionDe(ev.target);
    if (nombre) {
      ultimo = { nombre: nombre, t: Date.now() };
      if (clics < MAX_CLICKS) {
        clics++;
        enviar('section_click', { 'ep.section': nombre, 'ep.section_target': descripcion(ev.target) });
      }
      return;
    }
    if (ev.target.closest && ev.target.closest('.sticky-atc, sticky-atc')) { ultimo = { nombre: 'sticky-atc', t: Date.now() }; return; }
    if (ev.target.closest && ev.target.closest('product-form, form[action*="/cart/add"]')) { ultimo = { nombre: 'buy-buttons', t: Date.now() }; }
  }, true);

  function origenAtc() {
    if (ultimo.nombre && Date.now() - ultimo.t < ATTR_WINDOW_MS) { return ultimo.nombre; }
    return 'unknown';
  }

  /* ── section_add_to_cart: todo lo que llame a /cart/add (fetch y XHR) ────── */
  function itemsDe(body) {
    try {
      if (!body) { return []; }
      if (typeof body === 'string') {
        if (body.charAt(0) === '{') { body = JSON.parse(body); }
        else { body = new URLSearchParams(body); }
      }
      if (body instanceof URLSearchParams) { return [{ id: body.get('id'), quantity: Number(body.get('quantity') || 1) }]; }
      if (typeof FormData !== 'undefined' && body instanceof FormData) { return [{ id: body.get('id'), quantity: Number(body.get('quantity') || 1) }]; }
      if (body.items) { return body.items.map(function (i) { return { id: i.id, quantity: Number(i.quantity || 1) }; }); }
      if (body.id) { return [{ id: body.id, quantity: Number(body.quantity || 1) }]; }
    } catch (e) {}
    return [];
  }
  /* Solo cuenta si Shopify responde 2xx: un intento fallido (talla agotada, 422) no es un alta.
     La sección se fija en el momento de la petición, no al volver la respuesta. */
  function registrarAtc(items, via, origen) {
    items.forEach(function (it) {
      enviar('section_add_to_cart', {
        'ep.section': origen, 'ep.item_id': String(it.id || ''), 'epn.quantity': it.quantity || 1, 'ep.via': via
      });
    });
  }
  function esAdd(url) { return typeof url === 'string' && /\/cart\/add(\.js)?(\?|$)/.test(url); }

  var fetchOriginal = window.fetch;
  if (fetchOriginal) {
    window.fetch = function (input, init) {
      var items = null;
      var origen = null;
      try {
        var url = typeof input === 'string' ? input : (input && input.url);
        if (esAdd(url)) { items = itemsDe(init && init.body); origen = origenAtc(); }
      } catch (e) { items = null; }
      var promesa = fetchOriginal.apply(this, arguments);
      if (items && items.length) {
        promesa.then(function (res) { if (res && res.ok) { registrarAtc(items, 'fetch', origen); } }, function () {});
      }
      return promesa;
    };
  }
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__lejAdd = esAdd(url);
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (this.__lejAdd) {
        var items = itemsDe(body);
        var origen = origenAtc();
        if (items.length) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300) { registrarAtc(items, 'xhr', origen); }
          });
        }
      }
    } catch (e) {}
    return xhrSend.apply(this, arguments);
  };

  /* ── Arranque y DOM que cambia (cajón del carrito, secciones diferidas) ──── */
  var pendiente = 0;
  function refrescar() {
    if (pendiente) { return; }
    pendiente = setTimeout(function () { pendiente = 0; resolver(); observar(); }, 400);
  }
  function arrancar() {
    resolver();
    observar();
    new MutationObserver(refrescar).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('on:cart-drawer:after-open', refrescar);
    document.addEventListener('on:cart:after-merge', refrescar);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', arrancar); } else { arrancar(); }
}());
